interface IImage{
    date: {
      year: number
      month: number
      day: number
      hour: string
    }
    layer: {
      provider: string
      operation: string
    }
  }
interface IImageMinimal{
    date: string
    provider: string
    operation: string
}

// INPUT EJEMPLO: 2024-10-02T00-00-00_Sentinel2_gndvi1.json

export function getLayerImageFilename( image: IImage ){

    return `${image.date.year}-${image.date.month}-${image.date.day}T${image.date.hour.replace(':', '-').replace(':', '-')}_${image.layer.provider}_${image.layer.operation}.json`

}

export function parseImageFileName(fileName: string): IImageMinimal {
    // Remover la extensión del archivo
    const baseName = fileName.replace('.json', '');

    // Dividir el string por el guion bajo
    const [dateTime, provider, operation] = baseName.split('_');

    // Extraer la fecha y hora en partes
    const [date, time] = dateTime.split('T');

    // Convertir los guiones de la hora a dos puntos
    const formattedTime = time.replace(/-/g, ':');

    // Crear la fecha completa en el formato deseado
    const fullDate = `${date}T${formattedTime}Z`;

    // Crear y retornar el objeto con las propiedades
    return {
        date: fullDate,
        provider: provider,
        operation: operation
    }
}